import React from "react";
import ReactDOM from "react-dom";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, PageHeader, NavDropdown, MenuItem, Image, Col, Row, Navbar, Nav, NavItem, Dropdown, ButtonToolbar, DropdownButton } from "react-bootstrap";
import Materialicon from "../helpers/Materialicon";
import UserDropdown from "./UserDropdown";
import NotificationsDropdown from "./NotificationsDropdown";

export default class DashboardHeader extends React.Component {

	state = { AssideOpen: true };

	toggleAside = () => {
		this.setState((prevState) => {
			if (prevState.AssideOpen)
				document.querySelector("#body").className = "aside-collapse loged-in";
			else
				document.querySelector("#body").className = "loged-in";

			return { AssideOpen: !prevState.AssideOpen };
		});
	}

	render() {
		return (
			<div className= "has-aside">
				<Navbar.Header>
					<Navbar.Brand>
						<Link to="/"><b>TASK</b> <span>3.2</span></Link>
					</Navbar.Brand>
					<button className="btn" id="burger-menu" onClick={this.toggleAside}><Materialicon icon="menu" /></button>
					<div className="pull-right right-menu has-styled-dropdown">
						<NotificationsDropdown />
						<UserDropdown /> 
					</div>
				</Navbar.Header>
				<div className="aside-shadow" role="presentation" onClick={this.toggleAside} />
			</div>
		);
	}
}

DashboardHeader.propTypes = {
};


// WEBPACK FOOTER //
// ./src/components/navigation/DashboardHeader.js